import { filter, get } from 'lodash'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { Spinner } from '../../../components/generic'
import Operations from '../../../operations'
import Selectors from '../../../selectors'
import Dashboard from './Dashboard'

export const BillingDashboard = ({
  homeDetails,
  user,
  getHomeDetails,
  getSubscriptions,
  ...props
}) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (homeDetails?.id) {
      getHomeDetails(homeDetails.id)
      getSubscriptions()
    }
  }, [homeDetails?.id])

  if (!user || !homeDetails) return <Spinner />

  return (
    <Dashboard
      familySettings={{
        isActive: homeDetails.familySetupComplete,
        paymentType: homeDetails.familyPaymentType
      }}
      features={homeDetails}
      {...props}
    />
  )
}

BillingDashboard.propTypes = {
  homeDetails: PropTypes.object.isRequired,
  // activeResidentsCount: PropTypes.number,
  // carePlanNominative: PropTypes.string,
  // openChargebeePortal: PropTypes.func,
  getHomeDetails: PropTypes.func,
  getSubscriptions: PropTypes.func,
  // openExistingPlan: PropTypes.func,
  // openNewPlan: PropTypes.func,
  // peopleNominative: PropTypes.string,
  // subscriptions: PropTypes.array,
  user: PropTypes.object
}

const mapStateToProps = (state) => ({
  activeResidentsCount: filter(state.data.residents, { status: 'active' })
    .length,
  carePlanNominative: state.global.home.preferredCarePlansNominative,
  homeDetails: get(state, 'global.home'),
  peopleNominative: state.global.home.preferredPeopleNominative,
  subscriptions: Object.values(get(state, 'global.subscriptions') || {}),
  customer: get(state, 'global.customer'),
  user: Selectors.getCurrentUserProfile(state)
})

const mapDispatchToProps = (dispatch) => ({
  getHomeDetails: (id) => dispatch(Operations.getHomeDetails(id)),
  getSubscriptions: () => dispatch(Operations.getSubscriptions()),
  openChargebeePortal: () => dispatch(Operations.openChargebeePortal()),
  openExistingPlan: () => dispatch(Operations.openExistingPlan()),
  openNewPlan: (plan) => dispatch(Operations.openNewPlan(plan))
})

export default connect(mapStateToProps, mapDispatchToProps)(BillingDashboard)
